<script>
import PInput from "./p-input.vue";
import PTextarea from "./p-textarea.vue";
import PSelect from "./p-select.vue";
import PCard from "./p-card.vue";
import testService from "../services/test.js";
import getConstants from "../services/getConstants";
import { validate } from "../utils/";
import notificationService from "../plugins/notify";

export default {
    name: "p-request-test",
    components: {
        PInput,
        PSelect,
        PCard,
        PTextarea
    },
    data() {
        return {
             form: {},
            errors: [],
            success: false,
            submitDisabled: false,
            email: ""
        };
    },
    methods: {
        async submit(e) {
            this.submitDisabled = true;
            this.errors = validate(e);
            if (!!Object.keys(this.errors).length) {
                this.submitDisabled = false;
                return
            }
            try {
                const response = await testService.create(this.form);
                this.submitDisabled = false;
                this.success = true;
                this.email = this.form.email;
                this.notify(
                    'success',
                    'Seu teste está ativado e disponível por <b>uma semana!</b></br> <strong>Enviamos para o seu email os dados de acesso!! </strong>',
                    'Registrado com Sucesso'
                );
                this.reset(e);
                // setTimeout(()=>window.location.href = '/index.php#', 10000);
            } catch (error) {
                this.reset(e);
                this.notify('error', getConstants(error.data.message), 'Não foi possível cadastrar!');
                this.submitDisabled = false;
                this.success = false;
            }
        },
        async resend() {
            this.submitDisabled = true;
            try {
                const response = await testService.resend(this.email);
                this.submitDisabled = false;
                this.notify(
                    'success',
                    'Foi reenviado o e-mail com seus dados de acesso. Verifique sua caixa de entrada.',
                    'Enviado com sucesso'
                );
            } catch (error) {
                this.reset(e);
                this.notify('error', getConstants(error.data.message), 'Não foi possível enviar novo e-mail!');
                this.submitDisabled = false;
            }
        },
        reset(form) {
            form.target.reset();
            this.form = {};
            this.errors = {};
            this.submitDisabled = false;
        },
        notify(type, message, title)  {
            new notificationService()
                .type(type)
                .message(message)
                .title(title)
                .duration(7000)
                .notify()
        }
    },
    created: function() {}
};
</script>
<template>
<div class="wrapper">
    <div class="img-logo">
		<img src="includes/imgs/logo_login.png"/>
	</div>
    <p-card v-if="!success">
        <h2>Teste Grátis</h2>
        <hr class="separator"/>
        <p>Insira seus dados abaixo e pressione o botão solicitar</p>
        <form action="" @submit.prevent="submit" class="" novalidate>
            <div class="fields">
                <div class="">
                    <p-input name="name" required="true" minlength="3" label="Nome completo" type="text" :error="errors['name']" v-model="form.name"></p-input>
                </div>

                <div class="">
                    <p-input name="email" required="true" validate="email" label="email" type="text" :error="errors['email']" v-model="form.email"></p-input>
                    <p-input name="phone" required="true" mask="(##) # ########" label="Telefone" type="text" :error="errors['phone']" v-model="form.phone"></p-input>
                </div>
            </div>
            <div class="footer d-flex justify-content-end align-items-center">
                <button type="submit" :disabled="submitDisabled" class="btn btn-primary" name="button" title="Cadastrar"><span class="text">Solicitar</span></button>
            </div>
        </form>
    </p-card>

    <p-card v-if="success">
        <h2>Verifique seu e-mail</h2>
        <hr class="separator"/>
        <p>Enviamos um e-mail com os seus dados de acesso. Caso ele não esteja na sua caixa de entrada, verifique no spam.</p>
        <p>Se não encontrar o e-mail, solicite o reenvio clicando no botão abaixo.</p>
    
        <div class="footer d-flex justify-content-end align-items-center">
            <button type="submit" @click="resend()" :disabled="submitDisabled" class="btn btn-primary" name="button" title="Reenviar"><span class="text">Reenviar e-mail</span></button>
        </div>
        
    </p-card>
</div>
</template>
<style lang="scss">
.img-logo {
    text-align: center;
    margin-bottom: 20px;;
    img {
        width: 30%;
    }
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    height: 100vh;
    background-color: #47525d;
}
.p-card {
    padding: 30px 30px;
    width: 90%;
    max-width: 450px;;
    margin: 0 auto;
    flex-flow: column;

    h2, p {
        text-align: center;
    }
}
.separator {
    width: 80px;
    height: 5px;
    background-color: #007bff;
    margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/js/components/p-request-test.vue